import Header from 'components/Header';
import { Box, useTheme, Tabs, Tab } from '@mui/material';
import React, { useState } from 'react';
import { colorTheme } from '../../theme';
import PersonalDetails from './personalDetails';
import LifetimeGoals from './lifetineGoals';
import PlanDetails from './planDetails';
import Payments from './payments';
import Transactions from './transactions';
import PensionAggregate from './pensionAggregate';
import Chats from './chats';
import Documents from './documents';
import ComplaintRaised from './complaintRaised';
import { type ITabPanelProps } from 'types';
import { strings } from 'i18n/Strings';
import { customerDetailsTabs } from 'constants/constantText';
import Holdings from './holdings';

function TabPanel(props: ITabPanelProps): JSX.Element {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3, height: '75vh' }}>{children}</Box>}
    </div>
  );
}

const EmployessDetails = (): JSX.Element => {
  const theme = useTheme();
  const colors = colorTheme(theme.palette.mode);

  /* Tab Menu */
  const [value, setValue] = useState(0);
  const handleChange = (
    event: React.SyntheticEvent,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  return (
    <Box>
      <Box sx={{ display: 'flex' }}>
        <Header title={strings.displayText.employeeDetailText} />
      </Box>

      {/* Seporator */}
      <Box py={2} />

      {/* GRID & CHARTS */}
      <Box
        sx={{
          maxWidth: {
            xs: 320,
            sm: 480,
            md: '100%',
          },
          borderRadius: 3,
          px: 2,
          boxShadow: 2,
          bgcolor: 'background.paper',
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          indicatorColor="secondary"
          scrollButtons="auto"
          aria-label="scrollable auto tabs example"
          TabIndicatorProps={{
            style: {
              backgroundColor: colors.greenAccent[600],
            },
          }}
          sx={{
            '& .MuiTab-root.Mui-selected': {
              color: colors.greenAccent[500],
            },
          }}
        >
          {customerDetailsTabs.map((ele) => (
            <Tab key={ele} label={strings.displayText[ele]} />
          ))}
        </Tabs>
      </Box>

      <TabPanel value={value} index={0}>
        <PersonalDetails />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <LifetimeGoals />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <PlanDetails />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <Payments />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <Transactions />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <Holdings />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <PensionAggregate />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <Chats />
      </TabPanel>
      <TabPanel value={value} index={8}>
        <Documents />
      </TabPanel>
      <TabPanel value={value} index={9}>
        <ComplaintRaised />
      </TabPanel>
    </Box>
  );
};

export default EmployessDetails;
